<template>
    <section
        id="resetForm"
        class="tw-flex tw-h-[369px] tw-w-full tw-max-w-[423px] tw-flex-col tw-items-center tw-justify-center tw-rounded-xl"
    >
        <div
            class="tw-flex tw-h-[80px] tw-w-full tw-items-center tw-justify-center"
        >
            <svg
                class="tw-h-[80px] tw-w-[80px]"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M80 39.9999C80 47.1933 78.0977 53.9386 74.7804 59.7719C71.9112 64.8112 67.9807 69.1665 63.2878 72.5234C56.7318 77.2325 48.6902 79.9998 40.0039 79.9998C31.8758 79.9998 24.3137 77.5784 18.0014 73.4118C14.0238 70.786 10.5414 67.4684 7.71937 63.6319C2.86135 57.0125 0 48.8364 0 39.9999C0 22.1383 11.7127 7.0047 27.8825 1.87107C31.1919 0.817608 34.69 0.188679 38.3139 0.0393081C38.872 0.00786162 39.438 0 40.0039 0C40.5699 0 41.128 0.00786162 41.6862 0.0393081C45.31 0.180817 48.816 0.817608 52.1254 1.87107C68.2873 7.0047 80 22.1383 80 39.9999Z"
                    fill="#223F57"
                />
                <path
                    d="M74.7798 37.9006C73.4198 38.0735 72.1307 38.6081 71.038 39.4336L44.8299 59.2134C42.566 58.1599 39.9326 58.1599 37.6686 59.2134L11.4605 39.4336C10.3679 38.6081 9.07868 38.0814 7.71875 37.9006L36.1043 16.3833C39.1465 14.0877 43.3442 14.0877 46.3863 16.3833L74.7798 37.9006Z"
                    fill="#CA8A04"
                />
                <path
                    d="M70.3859 19.245V38.0658L44.9717 57.2481C42.7078 56.1946 40.0744 56.1946 37.8104 57.2481L12.1133 37.8614V19.2372H70.378L70.3859 19.245Z"
                    fill="#FAFAFB"
                />
                <path
                    d="M70.3859 38.0659V63.7656H12.1133V37.8694L37.8026 57.2561C40.0665 56.2027 42.6999 56.2027 44.9638 57.2561L70.378 38.0738L70.3859 38.0659Z"
                    fill="#F4F4F5"
                />
                <path
                    d="M45.9194 39.7658C46.1709 40.2611 46.7448 40.5284 47.4051 40.5284C47.8295 40.5284 48.3011 40.4183 48.7492 40.1904C49.8968 39.6008 50.4628 38.4766 50.0619 37.6433C50.0305 37.5883 44.5988 26.4094 44.5988 26.4094C44.5988 26.4094 44.5752 26.3622 44.5752 26.3544C44.3237 25.8591 43.7499 25.5918 43.0896 25.5918C42.6651 25.5918 42.1935 25.7019 41.7454 25.9298C40.6842 26.4723 40.2361 27.4549 40.3541 28.2882L41.1873 34.0113L39.3479 30.2221L39.3322 30.1907C39.3007 30.1199 39.2929 30.0885 39.2536 30.0177C39.002 29.5225 38.4282 29.2552 37.7679 29.2552C37.3434 29.2552 36.8718 29.3653 36.4237 29.5932C35.4883 30.0728 34.9224 30.9218 34.9774 31.6686L34.9617 36.9122C34.8438 36.8965 34.7259 36.8807 34.6001 36.8807C34.1756 36.8807 33.704 36.9908 33.2559 37.2188C32.1083 37.8084 31.5266 38.9404 31.9432 39.7658C32.1948 40.2611 32.7686 40.5284 33.4289 40.5284C33.8533 40.5284 34.325 40.4183 34.773 40.1904C35.6848 39.7265 36.2429 38.9011 36.2194 38.1779V34.4673L38.609 39.4278C38.6955 39.6008 38.7662 39.7108 38.7977 39.7658C39.0492 40.2611 39.623 40.5284 40.2833 40.5284C40.7078 40.5284 41.1794 40.4183 41.6275 40.1904C42.6729 39.6558 43.1603 38.6653 43.0267 37.8634L42.9717 37.5018L42.1777 32.046L45.8172 39.6008C45.8565 39.6715 45.8879 39.7187 45.9194 39.7737V39.7658Z"
                    fill="#0C1524"
                />
                <path
                    d="M51.6702 46.0857C51.623 46.0857 51.5837 46.0857 51.5523 46.0857C44.7133 45.7477 37.67 45.7005 30.6266 45.9521C30.3751 45.9521 30.1707 46.0778 30.0607 46.2822C29.9427 46.4945 29.9585 46.7696 30.0842 46.974C30.2021 47.1626 30.4144 47.2648 30.6502 47.257C33.7631 47.1469 36.9232 47.257 39.9889 47.3513L40.7436 47.3749C41.286 47.3906 41.8362 47.3985 42.3786 47.3985C43.998 47.3985 45.6173 47.3356 47.1973 47.2648C48.7381 47.2019 50.3338 47.1391 51.8903 47.1312C52.0789 47.1469 52.2597 47.0369 52.3541 46.8639C52.4562 46.691 52.4484 46.4787 52.3541 46.3451C52.2283 46.0621 51.8745 46.07 51.6544 46.07L51.6702 46.0857Z"
                    fill="#0C1524"
                />
                <path
                    d="M47.5193 50.6685C47.5193 50.6685 47.4721 50.6685 47.4485 50.6685C43.3216 50.3304 39.0846 50.2833 34.8318 50.5348C34.6825 50.5348 34.5567 50.6606 34.4938 50.865C34.4231 51.0772 34.4309 51.3524 34.5095 51.5567C34.5803 51.7454 34.7139 51.8476 34.8475 51.8397C36.7263 51.7297 38.6286 51.8397 40.4759 51.9341L40.9319 51.9576C41.262 51.9734 41.5922 51.9812 41.9223 51.9812C42.8971 51.9812 43.8718 51.9183 44.823 51.8476C45.7506 51.7847 46.7174 51.7218 47.6529 51.714C47.7629 51.7297 47.873 51.6196 47.9359 51.4467C47.9988 51.2738 47.9909 51.0615 47.9359 50.9279C47.8573 50.6449 47.645 50.6527 47.5114 50.6527L47.5193 50.6685Z"
                    fill="#0C1524"
                />
                <path
                    d="M74.7798 37.901V59.772C71.9106 64.8113 67.9801 69.1667 63.2872 72.5236C56.7312 77.2327 48.6896 80 40.0033 80C31.8752 80 24.313 77.5786 18.0008 73.4119C14.0232 70.7861 10.5408 67.4685 7.71875 63.6321V37.901C9.07868 38.0818 10.3679 38.6085 11.4605 39.434L11.9793 39.8271L37.6608 59.206H37.6686C38.3054 58.923 38.9735 58.7028 39.6496 58.5692C39.8775 58.522 40.1055 58.4906 40.3335 58.467C40.9388 58.4041 41.5598 58.4041 42.1651 58.467C42.393 58.4906 42.621 58.522 42.8489 58.5692C43.525 58.7028 44.1932 58.923 44.8299 59.2138H44.8377L70.2441 40.0315L71.038 39.434C72.1307 38.6085 73.4198 38.0818 74.7798 37.901Z"
                    fill="#F79F03"
                />
                <path
                    d="M63.2864 72.5237C56.7305 77.2328 48.6888 80.0001 40.0026 80.0001C31.8744 80.0001 24.3123 77.5787 18 73.4121L36.2136 60.0552C36.6695 59.7171 37.1569 59.4341 37.66 59.2061C38.509 58.8052 39.413 58.5615 40.3327 58.4671C40.938 58.3964 41.559 58.3964 42.1643 58.4671C43.084 58.5615 43.988 58.8052 44.837 59.2061C45.3401 59.4341 45.8275 59.7171 46.2834 60.0552L63.2864 72.5237Z"
                    fill="#FFAE00"
                />
                <path
                    d="M79.9969 20.2992C79.9969 22.5397 79.4073 24.6309 78.3697 26.447C77.4735 28.0114 76.2551 29.3715 74.793 30.4092C72.757 31.8715 70.2494 32.7363 67.5531 32.7363C65.0219 32.7363 62.6715 31.9816 60.7063 30.6844C59.4722 29.8668 58.3874 28.8369 57.5069 27.6419C55.9977 25.5822 55.1094 23.0429 55.1094 20.2913C55.1094 14.7332 58.749 10.0319 63.7799 8.43601C64.8097 8.10582 65.8945 7.90928 67.0264 7.86997C67.1994 7.86211 67.3723 7.85425 67.5531 7.85425C67.7339 7.85425 67.899 7.85425 68.0798 7.86997C69.2039 7.91714 70.2966 8.11368 71.3263 8.43601C76.3494 10.0319 79.9969 14.741 79.9969 20.2913V20.2992Z"
                    fill="#16A34A"
                />
                <path
                    d="M64.4107 26.4159L59.9771 21.9819C59.8514 21.8561 59.8514 21.6517 59.9771 21.526L60.9283 20.5747C61.0541 20.4489 61.2585 20.4489 61.3842 20.5747L64.6465 23.8373L73.1284 15.3546C73.2541 15.2288 73.4585 15.2288 73.5843 15.3546L74.5355 16.3058C74.6612 16.4316 74.6612 16.636 74.5355 16.7618L64.8823 26.4159C64.7565 26.5417 64.5522 26.5417 64.4264 26.4159H64.4107Z"
                    fill="#FAFAFB"
                />
            </svg>
        </div>
        <h2
            class="tw-w-full tw-pt-[40px] tw-text-center tw-text-[24px] tw-leading-[36px]"
        >
            {{ confirmationTitle }}
        </h2>
        <p
            class="tw-w-full tw-pt-[10px] tw-text-center tw-text-[16px] tw-leading-[24px] tw-text-white"
        >
            {{ confirmationDescription }} to <strong>{{ emailInput }}</strong>
            <br /><br />
            Didn’t get it? Please check your spam or resend the email link to
            try again.
        </p>
        <button
            type="button"
            :disabled="isEmailSent"
            class="tw-text-thite tw-btn-secondary tw-mt-[48px] tw-h-[40px] tw-w-full tw-border-[white] tw-bg-[#00101D] tw-p-[8px] tw-text-[16px] tw-leading-[24px]"
            @click="() => handleEmailSend()"
        >
            RESEND EMAIL {{ isEmailSent ? formattedTimer : "" }}
        </button>
        <a
            id="loginToggle"
            class="tw-pt-[30px] tw-text-center tw-text-[14px] tw-leading-[21px] tw-text-white"
            @click="() => emit('change-form', 'login-email')"
            >Close</a
        >
    </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";

const props = defineProps({
    emailInput: String,
    endpointUrl: String,
    usecsrftoken: Boolean,
    userStore: Object,
    confirmationTitle: String,
    confirmationDescription: String,
    confirmationType: String,
});

const isEmailSent = ref(false);

const emit = defineEmits(["change-form", "show-notification"]);

function handleEmailSend(withTimer = true) {
    if (withTimer) {
        isEmailSent.value = true;

        const timer = 30;
        let time = timer;

        const interval = setInterval(() => {
            time--;
            const minutes = Math.floor(time / 60);
            const seconds = time % 60;
            formattedTimer.value = `${minutes < 10 ? "0" : ""}${minutes}:${
                seconds < 10 ? "0" : ""
            }${seconds}`;

            if (time <= 0) {
                clearInterval(interval);
                isEmailSent.value = false;
                formattedTimer.value = "00:30";
            }
        }, 1000);
    }
    axios
        .post(props.endpointUrl, { email: props.emailInput })
        .then(() => {
            if (withTimer) {
                emit("show-notification", {
                    icon: "check",
                    text: "Email sent. Please check your inbox.",
                });
            }
        })
        .catch((e) => {
            console.error("Error sending email", e);
        });
}

const formattedTimer = ref("00:30");

onMounted(() => {
    if (props.confirmationType === "reset") {
        handleEmailSend(false);
    }
});
</script>
